/**
 * Estilos compartidos para modales de Travel Kit
 * Alineados con el diseño del dashboard (Dashboard.css, PurchaseChoiceModal)
 */

export const TRAVEL_KIT_MODAL = {
	// Colores
	primary: "#6366F1",
	primaryGradient: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
	primaryGradientHover: "linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
	textPrimary: "#1a1a2e",
	textMuted: "#64748B",
	border: "rgba(0, 0, 0, 0.06)",
	borderHover: "rgba(99, 102, 241, 0.3)",
	bgInput: "#f8fafc",
	bgCard: "#fff",

	// Radios
	radiusInput: "12px",
	radiusButton: "12px",
	radiusModal: "16px",

	// Sombras
	shadowPrimary: "0 4px 14px rgba(99, 102, 241, 0.35)",
	shadowPrimaryHover: "0 6px 20px rgba(99, 102, 241, 0.45)",
	shadowModal: "0 10px 40px rgba(0, 0, 0, 0.08)",
};

/** Estilos para TextField dentro de modales Travel Kit */
export const textFieldSx = {
	"& .MuiOutlinedInput-root": {
		bgcolor: TRAVEL_KIT_MODAL.bgInput,
		borderRadius: TRAVEL_KIT_MODAL.radiusInput,
		"&:hover fieldset": { borderColor: "#cbd5e1" },
		"&.Mui-focused fieldset": {
			borderColor: TRAVEL_KIT_MODAL.primary,
			borderWidth: "2px",
		},
	},
	"& .MuiInputLabel-root": { color: TRAVEL_KIT_MODAL.textMuted },
	"& .MuiInputLabel-root.Mui-focused": { color: TRAVEL_KIT_MODAL.primary },
};

/** Estilos para BasicModal contentSx */
export const modalContentSx = {
	bgcolor: TRAVEL_KIT_MODAL.bgCard,
	borderRadius: TRAVEL_KIT_MODAL.radiusModal,
	border: `1px solid ${TRAVEL_KIT_MODAL.border}`,
	boxShadow: TRAVEL_KIT_MODAL.shadowModal,
};

/** Estilos para botón primario (Guardar) */
export const primaryButtonSx = {
	textTransform: "none",
	fontWeight: 600,
	px: 3,
	py: 1.25,
	borderRadius: TRAVEL_KIT_MODAL.radiusButton,
	background: TRAVEL_KIT_MODAL.primaryGradient,
	boxShadow: TRAVEL_KIT_MODAL.shadowPrimary,
	"&:hover": {
		background: TRAVEL_KIT_MODAL.primaryGradientHover,
		boxShadow: TRAVEL_KIT_MODAL.shadowPrimaryHover,
	},
};

/** Estilos para botón secundario (Cancelar) */
export const secondaryButtonSx = {
	textTransform: "none",
	fontWeight: 600,
	px: 3,
	py: 1.25,
	borderRadius: TRAVEL_KIT_MODAL.radiusButton,
	backgroundColor: "transparent",
	color: TRAVEL_KIT_MODAL.textMuted,
	border: `1px solid ${TRAVEL_KIT_MODAL.border}`,
	"&:hover": {
		borderColor: TRAVEL_KIT_MODAL.primary,
		backgroundColor: "rgba(99, 102, 241, 0.04)",
	},
};
